import React from "react";
import PaddedSection from "../PaddedSection";
import styled from "styled-components";
import {IdeaDetailsFields} from "./IdeaDetailFields";
import ViewPortfolioList from "./portfolios/ViewPortfolioList";

const Container = styled(PaddedSection)`
    display: flex;
    flex-grow: 1;
    padding-bottom: 37px;
`;

const FieldsContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-basis: 200px;
`;

const PortfolioListContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-basis: 520px;
    min-width: 370px;
    margin-left: 16px;
`;

const IdeaDetailsViewTab = ({idea, userIdentity, clock}) => (
    <Container className="t-view-content">
        <FieldsContainer>
            <IdeaDetailsFields idea={idea} userIdentity={userIdentity} clock={clock}/>
        </FieldsContainer>
        <PortfolioListContainer>
            <ViewPortfolioList portfolios={idea.portfolios} authorId={idea.authorId} currentUserId={userIdentity.imeUserId}/>
        </PortfolioListContainer>
    </Container>
);

export default IdeaDetailsViewTab;